export const modifyUrlForLanguage = (url: string, language: string) => {
  const urlObj = new URL(url);

  if (language === 'ru') {
    urlObj.hostname = `${language}.${urlObj.hostname}`;
  }

  return urlObj.toString();
};
